import * as api_config from '../config/api_config'

export default {
    getCategories(axios, query = {}) {
        return axios.get(`${api_config.ADDRESS}/categories`, { params: query, headers: api_config.HEADERS })
    },
    getCategory(axios, path = null) {
        let location = path || '/categories'
        return axios.get(`${api_config.ADDRESS}${location}`, { headers: api_config.HEADERS })
    },
    getFilters(axios, path) {
        let location = path + "/filters"
        return axios.get(`${api_config.ADDRESS}${location}`, { headers: api_config.HEADERS })
    },
    getDesignerTips (axios, permalink) {
        return axios.get(`${api_config.ADDRESS}/categories/designer_tips`, { params: { permalink } , headers: api_config.HEADERS })
    }
};
